import React, { useState } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';
import { media } from 'components/responsive';
const messages = defineMessages({
    cvdTitle: 'CVD Prevention Decathlon (2023–24)',
    title: 'Hard Facts, Real Impact, Changed Lives',
    readMore: 'Read more about the trial results',
    blockTitle: 'T2 Diabetes Prevention Decathlon (2021–24)',
    nhs1text: '<strong>80%</strong> step increase (over 22 weeks)',
    nhs2text: '<strong>3kg</strong> weight loss (up to 10kg)',
    nhs3text: '<strong>93%</strong> completion rates',
    nhs4text: '<strong>75%</strong> Ethnic minority participation',
    nhs5text: '<strong>HIN Evaluation due H2 2025</strong>',
    cvd1text: '<strong>96%</strong> reduced their CVD risk',
    cvd2text: '<strong>75%</strong> completion rates',
    cvd3text: '<strong>42%</strong> increase in movement (over 3 months)',
    cvd4text: '<strong>72%</strong> felt supported and connected between sessions',
    cvd5text: '<strong>Equity of outcome</strong> across age, ethnicity, socioeconomic deprivation population characteristics',
    cvd6text: '<strong>Statistically significant reductions in cholesterol and BP</strong> for those with elevated levels at baseline',
    readMoreCVD: 'Read Full 2024 CVD Programme Evaluation',
});
var View;
(function (View) {
    View[View["NHS"] = 0] = "NHS";
    View[View["CVD"] = 1] = "CVD";
})(View || (View = {}));
const Button = ({ onClick, children, isSelected, num }) => {
    return (React.createElement(HeadButton, { onClick: onClick },
        React.createElement(Num, { isSelected: isSelected }, num),
        "\u00A0",
        React.createElement(TextWrapper, null, children)));
};
const cvdFacts = ['cvd1text', 'cvd2text', 'cvd3text', 'cvd4text', 'cvd5text', 'cvd6text'];
const nhsFacts = ['nhs1text', 'nhs2text', 'nhs3text', 'nhs4text', 'nhs5text'];
const CaseStudy = () => {
    const [view, setView] = useState(View.CVD);
    const facts = view === View.CVD ? cvdFacts : nhsFacts;
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, { id: "facts" },
            React.createElement(FormattedMessage, { ...messages.title })),
        React.createElement(Layout, null,
            React.createElement(Head, null,
                React.createElement(Button, { onClick: () => setView(View.NHS), isSelected: view === View.NHS, num: 1 },
                    React.createElement(FormattedMessage, { ...messages.blockTitle })),
                React.createElement(Button, { onClick: () => setView(View.CVD), isSelected: view === View.CVD, num: 2 },
                    React.createElement(FormattedMessage, { ...messages.cvdTitle }))),
            React.createElement(Facts, null, facts.map((i18nkey) => (React.createElement(Fact, { key: i18nkey },
                React.createElement(FormattedMessage, { ...messages[i18nkey], values: { break: React.createElement("br", null) } }))))),
            view === View.NHS && (React.createElement(Link, null,
                React.createElement("div", null,
                    React.createElement("a", { href: "https://www.healthtechdigital.com/nhs-sweatcoin-partner-to-roll-out-an-expanded-new-diabetes-prevention-programme-to-tackle-10-bn-year-problem/", target: "_blank", rel: "noreferrer" },
                        React.createElement(FormattedMessage, { ...messages.readMore }))))),
            view === View.CVD && (React.createElement(Link, null,
                React.createElement("a", { href: "https://docs.google.com/presentation/d/1dbXmKxt63nKK5OTkpmynGsA8bGZ9HAZX/edit#slide=id.g32830aa743a_0_49", target: "_blank", rel: "noreferrer" },
                    React.createElement(FormattedMessage, { ...messages.readMoreCVD })))))));
};
const Title = styled.h2 `
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 1.25;
  color: #5e2394;
  text-align: center;
  margin-bottom: 40px;
  padding: 0 50px;
`;
const Layout = styled.div `
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 50px;
  position: relative;
  padding: 50px 16px 50px;
  margin-bottom: 50px;

  ${media.desktop `
    padding: 50px 90px 50px;
    margin-bottom: 164px;
  `};
`;
const Link = styled.div `
  display: inline-flex;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  align-items: center;
  align-self: center;
  color: #032555;
  gap: 10px;
  margin: 60px auto;
  padding: 18px 85px;
  border-radius: 50px;
  border: 2px solid #cb00ad;

  a {
    text-decoration: none;
    text-align: center;
  }
`;
const Head = styled.div `
  display: flex;
  width: 100%;
  gap: 100px;
  flex-direction: column;

  ${media.desktop `
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}
`;
const HeadButton = styled.button `
  display: flex;
  align-items: center;
  border: none;
  background: none;
  color: #191841;
  font-family: Inter;
  gap: 8px;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.25;
  cursor: pointer;

  ${media.desktop `
  max-width: 50%;
  `}
`;
const Num = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  aspect-ratio: 1;
  flex-shrink: 0;
  border: 1px solid #8d89a5;
  width: 60px;
  background: ${(props) => (props.isSelected ? '#8832fc' : '#fdeffe')};
  color: ${(props) => (props.isSelected ? '#fff' : '#4D07D8')};
  box-shadow: ${(props) => (props.isSelected ? '0 0 20px -5px #4d07d8' : '0 0 20px -16px #4d07d8')};
`;
const Facts = styled.div `
  margin-top: 72px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-row: repeat(auto, 1fr);
  gap: 40px;
  justify-content: space-between;

  ${media.desktop `
grid-template-columns: repeat(3, minmax(150px, 200px));
  grid-template-row: repeat(2, 1fr);
  gap: 40px;

    `}
`;
const Fact = styled.div `
  color: #000;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: -0.036px;

  strong {
    display: inline;
    color: #5e2394;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.048px;
  }
`;
const TextWrapper = styled.span `
  text-align: left;
`;
export default CaseStudy;
